(function(angular) {
    'use strict';

    var approveAddEdit = function($state, $stateParams) {

        this.requestId = $stateParams.requestId;
        this.approvalEditMode = $state.is('communicationsEditApprovalRequest');

        this.returnToParent = function() {
            $state.go('communicationsList');
        };
    };

    approveAddEdit.$inject = ['$state', '$stateParams'];

    angular.module('onvio.documents')
        .controller('approveAddEdit', approveAddEdit);

})(angular);
